export default __webpack_public_path__ + "static/media/Aeonik-SemiBold.03b773a6.woff";